// src/pages/DRIVE.js

import React from 'react';
import TopBar from '../components/TopBar';
import PowerBIEmbed from '../components/PowerBIEmbed';

const DRIVE = ({ userClaims }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <TopBar currentPage="drive" userClaims={userClaims} />
      
      <div className="p-4">
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">DRIVE - Last Mile Delivery Dashboard</h1>
          </div>
          
          <div className="w-full" style={{ height: 'calc(100vh - 200px)' }}>
            <PowerBIEmbed
              reportId="012635a9-02e9-4d41-b23a-63f6498d861e"
              workspaceId="7d441575-4aa9-4260-99dd-543f002c0340"
              height={800}
          
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DRIVE; 